<template>
  <div>
    <Header></Header>
    <section>
      <div class="container">
        <div class="box">
          <div class="main-message">
            <div>
              <p class="message">
                本人確認のため、確認メールをお送りしました。
                <br />
                メールに記載されている確認リンクをクリック後、続行ボタンをクリックしてください。
              </p>
            </div>
            <div>
              <a href="/">
                <button type="button" class="c_btn">
                  続行
                </button>
              </a>
            </div>
          </div>

          <div>
            <p class="message">
              確認メールが届かない場合は再送してください。
              <a
                v-if="!hasResent"
                class="link resend-text"
                @click.once="resend()"
              >
                再送する
              </a>
              <a v-else class="resent-text" @click.once="resend()">
                再送しました
              </a>
            </p>
          </div>

          <div>
            <p class="message">
              メールアドレスを間違えた場合は、会員登録をやり直してください。
            </p>
            <a class="link c_strong" @click="$auth.logout()">
              サインアウト
            </a>
          </div>
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      hasResent: false
    };
  },
  methods: {
    resend() {
      this.$authAxios.get("/api/verify-email/resend");
      this.hasResent = true;
    }
  }
};
</script>

<style>
@import "../font/icomoon/style.css";
@import "../css/reset.min.css";
@import "../css/common.css";

footer {
  bottom: 0;
  width: 100%;
}

section {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 375px); /* ヘッダーとフッターの高さ分を引く */
  min-height: 400px;
  padding: 20px;
  background-color: #e9ecef;
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.box {
  border-top: 5px solid #78ba00;
  border-radius: 5px;
  padding: 20px;
  text-align: center;
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.message {
  margin-bottom: 10px;
}

.c_btn {
  width: 80%;
  margin-bottom: 20px;
}

.main-message {
  border-bottom: 1px dashed #cecece;
  margin-bottom: 10px;
}

.link {
  cursor: pointer;
}

.resend-text {
  color: #78ba00;
  font-weight: 700;
  margin-bottom: 20px;
}

.resent-text {
  color: #a5a5a5;
  font-weight: 700;
  margin-bottom: 20px;
}
</style>
